import { render, staticRenderFns } from "./CruResource.vue?vue&type=template&id=256bd83a&scoped=true&"
import script from "./CruResource.vue?vue&type=script&lang=js&"
export * from "./CruResource.vue?vue&type=script&lang=js&"
import style0 from "./CruResource.vue?vue&type=style&index=0&id=256bd83a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256bd83a",
  null
  
)

export default component.exports